export default __webpack_public_path__ + "static/media/under-construction.ce20fb83.jpeg";